import '@images/favicon.ico';
